import angular from 'angular';

import PageNotFoundComponent from './page-not-found.component';

const PageNotFoundModule = angular
    .module('control-room.commons.layout.components.page-not-found', [])
    .component('crPageNotFound', PageNotFoundComponent);

export default PageNotFoundModule;
